<template>
    <div>
        <nav class="navbar navbar-toggleable-md navbar-light bg-navblue">
            <div class="container nav-mobile">
                <div class="navbar-header">
                    <form class="form-inline my-2  d-block d-lg-none res-book">
                        <a :href="currentURL" class="btn btn-cust">Book an Appointment</a>
                    </form>

                    <div class="menu-btnhold d-block d-lg-none">
                        <a href="javascript:void(0);" class="navbar-toggle burger-menu pull-right" data-toggle="tooltip" title="" data-original-title="Menu">
                            <div class="bar1"></div>
                            <div class="bar2"></div>
                            <div class="bar3"></div>
                        </a>
                    </div>  
                </div>                    
                <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                    <ul class="navbar-nav mr-auto">
                        <!-- <li class="nav-item"><a class="nav-link" :href="homeurl"><span><i class="material-icons">home</i></span></a></li> -->
                        <li class="nav-item"><a class="nav-link" :href="minisiteUrl"><span><i class="material-icons">home</i></span></a></li>
                        <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/about-me/">About Me</a></li>
                        <li class="dropdown active" v-if="showLinks=='y'"><a href="#" class="dropdown-toggle" data-toggle="dropdown">Resources <b class="caret"></b></a>
                            <ul class="dropdown-menu">
                                <li><a href="javascript:void(0)">Articles</a></li>
                                <li><a href="javascript:void(0)">Videos</a></li>
                            </ul>
                        </li>
                        <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/travel-medicine/">Travel Medicine</a></li>
                        <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/infectious-diseases/">Infectious Diseases</a></li>
                        <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/patient-reviews/">Patient Reviews</a></li>
                        <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/contact/">Contact</a></li>

                    </ul>                
                    <!-- <form class="form-inline my-2 d-none d-lg-block">
                        <a :href="currentURL" class="btn btn-cust">Book an Appointment</a>
                    </form>               -->
                </div>

                <div class="slidebarmenu" style="display:none;">
                    <a href="javascript:void(0);" class="sidebar-close"> <i class="fa fa-close" aria-hidden="true"></i></a>
                        <ul class="navbar-nav">
                            <!-- <li class="nav-item"><a class="nav-link" href="http://doctorswati.com/">Home</a></li> -->
                            <li class="nav-item"><a class="nav-link" @click.prevent="goHome()">Home</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/about-me/">About Me</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/articles/">Articles</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/travel-medicine/">Travel Medicine</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/infectious-diseases/">Infectious Diseases</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/videos/">Videos</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/patient-reviews/">Patient Reviews</a></li>
                            <li class="nav-item" v-if="showLinks=='y'"><a class="nav-link " href="http://doctorswati.com/contact/">Contact</a></li>
                        </ul>
                </div>
            </div>
        </nav>
        <!-- Nav ends -->
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    name: "Header",
     computed: {
        ...mapGetters([
            'minisiteUrl',])
        },
    data () {
        return {
            "showLinks": "n",
            "currentURL": "",
            "homeurl": "#"
        }
    },
    methods: {
        getURLDetails() {
            var currentUrl = window.location.hostname;
            console.log(currentUrl);
            this.currentURL = window.location.pathname;
            if( currentUrl.indexOf('arista') >= 0){
                this.showLinks = "y";
            }
        },
        goHome(){
            //this.clearLocalStorage();
            var currentUrl = window.location.hostname;
            
            if( currentUrl.indexOf('arista') >= 0){
                this.homeurl = process.env.VUE_APP_CLINIC_URL_ARISTA;
            }

            if( currentUrl.indexOf('pranav-skin-and-cosmetology-clinic') >= 0){
                this.homeurl = process.env.VUE_APP_CLINIC_URL_PRANAV;
            }

            if( currentUrl.indexOf('acharya-tulasi-jain-hospital') >= 0){
                this.homeurl = process.env.VUE_APP_CLINIC_URL_SANGEETHA;
            }

            if( currentUrl.indexOf('padmanabhan-clinic') >= 0){
                this.homeurl = process.env.VUE_APP_CLINIC_URL_PADMANABHAN;
            }

            if( currentUrl.indexOf('priyans-dental-clinic') >= 0){
                this.homeurl = process.env.VUE_APP_CLINIC_URL_PRIYANS;
            }

            if( currentUrl.indexOf('vijay-seshadri-clinic') >= 0){
                this.homeurl=process.env.VUE_APP_CLINIC_URL_VIJAYSESHADRI;
            }
            if( currentUrl.indexOf(process.env.VUE_APP_CLINIC_NAME_NEWLIFEHOSPITALS) >= 0){
                this.homeurl=process.env.VUE_APP_CLINIC_URL_NEWLIFEHOSPITALS;
            }
            if( currentUrl.indexOf(process.env.VUE_APP_CLINIC_NAME_NIRVANACENTER) >= 0){
                this.homeurl=process.env.VUE_APP_CLINIC_URL_NIRVANACENTER;
            }
            // if( currentUrl.indexOf('localhost') >= 0){
            //     this.homeurl=process.env.VUE_APP_CLINIC_URL_VIJAYSESHADRI;
            // }

            console.log("currentUrl >> " + currentUrl)
            console.log("homeurl >> " + this.homeurl);
            window.location.href = this.homeurl;
        },
    },
    mounted(){
        this.getURLDetails();
        //this.goHome();
        console.log(this.showLinks);
    },
};
</script>

<style>
</style>
